import React, { useState } from 'react'
import styled from 'styled-components'
import { Flex, Text, getPaletteColor } from 'pcln-design-system'
import fetch from 'isomorphic-unfetch'
import CONFIG from 'isomorphic-config'
import { CONTENT } from './signup-content'
import EmailSignUpForm from './EmailSignUpForm'
import analytics from '../../utils/analytics'

const URL = CONFIG.client.email.optIn

const EmailContainer = styled(Flex)`
  border-bottom: solid 1px ${getPaletteColor('border.base')};
  text-align: center;
`

type EmailSignUpTypes = {
  sourceId: string
  category: string
  children: React.ReactNode
}

export default function EmailSignUp({
  sourceId,
  category,
  children
}: EmailSignUpTypes) {
  const [isLoading, setIsLoading] = useState(false)
  const [success, setSuccess] = useState(false)
  const [error, setError] = useState<Error | null>(null)

  const submitEmail = async ({
    signUpPromotion
  }: {
    signUpPromotion: string
  }): Promise<void> => {
    setIsLoading(true)

    const submission = {
      alertSubscribeList: [
        {
          emailAddress: signUpPromotion,
          sourceId,
          alertId: 1,
          channelType: 'EMAIL',
          contactSourceType: 'CS',
          partnerCode: 'PCLN'
        }
      ]
    }

    try {
      const response = await fetch(URL, {
        method: 'POST',
        body: JSON.stringify(submission),
        headers: { 'content-type': 'application/json' }
      })
      if (response.ok) {
        const body = await response.json()
        if (body.success) {
          setSuccess(true)
          analytics.fireEvent({
            action: 'Email Confirm',
            category,
            event: 'gtm-pageload-event',
            label: 'Thank You'
          })
        } else {
          throw new Error(body.errorDesc || 'Email registration failure')
        }
      } else {
        throw new Error(response.statusText || 'Email registration failure')
      }
    } catch (err) {
      setError(err)
    }
    setIsLoading(false)
  }

  return (
    <EmailContainer color="background.lightest" mb={0} justifyContent="center">
      {success ? (
        <Text fontSize={3} fontWeight="bold" my={1} py={3} textAlign="center">
          {CONTENT.successMessage}
        </Text>
      ) : (
        <EmailSignUpForm
          category={category}
          apiError={error}
          isLoading={isLoading}
          submitEmail={submitEmail}
        >
          {children}
        </EmailSignUpForm>
      )}
    </EmailContainer>
  )
}
